import { render, staticRenderFns } from "./his-layout.vue?vue&type=template&id=3fca0e1a"
import script from "./his-layout.vue?vue&type=script&lang=js"
export * from "./his-layout.vue?vue&type=script&lang=js"
import style0 from "./his-layout.vue?vue&type=style&index=0&id=3fca0e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports